<template>
  <div>
    <div class="phone">
      <object
        data="https://ot.jfshou.cn/privilege/aggregateExpressH5/#/expressHome?environmentSign=1&share_code=823SugYvW&extra=666_58_47"
        style="width: 100%; height: 100%"></object>

    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="less" scoped>
.phone {
  width: 30vw;
  height: 100%;
}
</style>